import AbateExcelReportStrategy from './strategies/abateExcelReportStrategy';
import ComercializacaoExcelReportStrategy from './strategies/comercializacaoExcelReportStrategy';

type TReportStrategy = AbateExcelReportStrategy | ComercializacaoExcelReportStrategy;

interface IReportStrategyDeps {
  formatarDataBR: (value: string | null | undefined) => string;
  normalizeMesKey: (value: unknown) => string;
}

export function createRelatorioExcelReportStrategy(tabKey: string, deps: IReportStrategyDeps): TReportStrategy | null {
  switch (tabKey) {
    case 'ABATE':
      return new AbateExcelReportStrategy(deps);
    case 'COMERCIALIZACAO':
      return new ComercializacaoExcelReportStrategy(deps);
    default:
      return null;
  }
}
